:host {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	background-color: rgb(var(--smoothly-input-background));
}

:host:not([in-calendar])>smoothly-input-select {
	display: flex;
	flex: 1;
}

:host[looks=line],
:host[looks=border],
:host[looks=transparent] {
	gap: 2em;
}

:host:not([previous])>smoothly-icon:first-of-type,
:host:not([next])>smoothly-icon:last-of-type {
	display: none;
}
:host>smoothly-icon {
	display: flex;
	align-self: center;
	cursor: pointer;
}
:host>smoothly-icon.disabled {
	opacity: 0.5;
	cursor: not-allowed;
}


